exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".w-navbar[data-v-71ce9efd]{background-color:var(--bb-darkgrey);height:50px}.icon-arrow_back-navbar[data-v-71ce9efd]{fill:#aaa!important;height:24px!important;width:24px!important;margin-left:3px!important}.b-steps li[data-v-71ce9efd]{width:5px;height:5px;border-radius:50%;background:var(--bb-midgrey);margin:0 1px}.b-steps li.is-active[data-v-71ce9efd]{background:var(--bb-green)}.bb-popup__content[data-v-71ce9efd]{padding-top:15px}", ""]);

// exports
